<template>
  <div class="d-flex">
    <span class="t-sm t-600 pr-1">Compare:</span>
    <dropdown
      placement="bottom-end"
      noPadding
    >
      <template #button>
        <span class="t-sm t-blue t-600 cursor-pointer d-flex align-items-center">{{ selectedOption.label }} <i class="t-xs fa fa-chevron-down t-secondary ml-1" /></span>
      </template>
      <a
        v-for="(option, index) in options" :key="index"
        href="#" @click.prevent="$emit('selected', option.value)"
        class="bg-grey-hover d-block py-2 px-3 t-primary d-flex"
      >
        <i class="fa fa-check t-secondary mr-2 mt-1" :class="{ 'invisible': !option.active }" />
        <span class="t-600 d-md-flex align-items-center">
          <span class="mr-md-2">{{ option.label }}
            <i class="fa fa-lock t-blue ml-2 semi-transparent" v-if="option.locked" />
          </span>
        </span>
      </a>
    </dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/shared/form/Dropdown'

export default {
  name: 'compareButton',
  components: {
    Dropdown
  },
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    selectOption (option) {
      if (option.value !== this.selectedOption.value) {
        this.$emit('selected', option.value)
      }
    }
  },
  computed: {
    selectedOption () {
      return this.options.find(option => option.active)
    }
  }
}
</script>
